import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, AUTH_TOKEN } from '../Context';
import { GetTemplateType } from './TemplateForm';


export default function Group({}) {
  const [group, setGroup] = useState([]);
  // const [groups, setGroups] = useState([]);
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  let { groupId } = useParams();
  groupId = Number(groupId);


  React.useEffect(() => {

    let group = axios_api.get(api_url + '/show_group/' + groupId, {
      headers: {"Authorization": token},
    });

    group.then(
      (result) => {
        let apiReturnedGroup = result.data;
        setGroup(apiReturnedGroup);

        /*
        let groups = axios_api.get(api_url + '/groups', {
          headers: {"Authorization": token},
        });

        groups.then(
          (result) => {
            let apiReturnedGroups = result.data;
            setGroups(apiReturnedGroups);

          },
          (error) => {
            console.log(error)
            setGroups([]);
          }
        );
        */

      },
      (error) => {
        console.log(error)
        setGroup([]);
      }
    );

  }, []);


  let groupMembers = []
  if (group.user_set) {
    for (let i in group.user_set) {
      groupMembers.push(
        <li key={group.user_set[i].id} className="my-1">{group.user_set[i].username}</li>
      )
    }
  }

  let groupTemplates = []
  if (group.template_set) {
    for (let i in group.template_set) {

      //let templateType = GetTemplateType(group.template_set[i].type)

      groupTemplates.push(
        <li key={group.template_set[i]} className="my-1">{group.template_set[i]}</li>
      )
    }
  }


  return (
    <>
      <h4 className="m-3"><Link to={`/templates`}>к списку шаблонов и групп</Link></h4>
      <div className="row">
        <div className="col-4 m-3">
          <div className="card lk-border category-card">
            <div className="card-header text-center">
              <h4 className="m-2">{group.name}</h4>
            </div>   
            <div className="card-body p-5">
              <h5 className="">Название группы:</h5>
              <div className="ps-3"> 
                <b>{group.name}</b> 
              </div>
              <h5 className="mt-5">Лаборатории:</h5>
              <div className="ps-3">
                {groupMembers.length > 0 ? groupMembers : <p>в группе нет пользователей</p>}
              </div>
              <h5 className="mt-5">Шаблоны группы: </h5>
              <div className="ps-3">
                {groupTemplates}
              </div>
            </div>
          </div> 
        </div> 
      </div> 
    </>
  )
}